/** @type{(
	ctx: any, 
	services: { sgApiClient: import("../interfaces/ISGApiClient").ISGApiClient }
) => Promise<import("../interfaces/ISGApiClient").PlasmidSet> } */
const sets = (_, { sgApiClient }) => sgApiClient.getSets();

export default sets;
